module.exports = __webpack_public_path__ + "static/media/Nautilus.6ee39f8f.png";